import React from 'react';
import { Link } from 'react-router-dom';
import { EyeIcon } from '../../../components/jds/icons';
import { JdsTag } from '../../../components/jds/JdsTag';
import { formatCurrency } from '../../../helpers/formatCurrency';
import { buildComparisonRows, formatCycle } from '../../PaymentPlans/utils';
import '../../../components/jds/jds.css';

// Mesmos itens/benefícios do comparativo de planos, para um plano só. Painel
// fixo ao lado do formulário (sticky) sempre que há plano selecionado,
// acompanhando as mudanças em tempo real.
export function PlanDetailsPanel({ plan, addonQuantities = {} }) {
  const rows = buildComparisonRows([plan]);

  return (
    <aside className="jds-card jds-side-panel" aria-label="Detalhes do plano">
      <div className="d-flex justify-content-between align-items-start mb-4">
        <div>
          <h2 className="jds-title-md">{plan.name}</h2>
          <div
            className="d-flex align-items-center mt-2"
            style={{ gap: 'var(--space-8)' }}
          >
            <span
              style={{
                color: 'var(--fg-brand-strong)',
                fontWeight: 'var(--fw-semibold)',
              }}
            >
              {formatCurrency(plan.amount)}
            </span>
            <JdsTag color="brand" label={formatCycle(plan.cycleDays)} />
            <JdsTag
              dot
              color={plan.active ? 'success' : 'error'}
              label={plan.active ? 'Ativo' : 'Inativo'}
            />
          </div>
        </div>
      </div>

      <h3 className="jds-title-xs mb-2">Itens incluídos</h3>
      {rows.length === 0 ? (
        <p className="text-muted mb-0">Este plano não possui itens.</p>
      ) : (
        rows.map((row) => {
          const addonQuantity = addonQuantities[row.id];
          return (
            <div
              key={row.code}
              className="jds-detail-row"
              style={
                addonQuantity
                  ? {
                      background: 'var(--bg-brand-subtler)',
                      boxShadow: 'inset 4px 0 0 var(--border-brand-default)',
                      paddingLeft: 'var(--space-12)',
                    }
                  : undefined
              }
            >
              <span className="text-muted">
                <Link
                  to={`/payments/items/${row.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted mr-2"
                  aria-label={`Abrir detalhes de ${row.name} em nova guia`}
                  title="Abrir em nova guia"
                >
                  <EyeIcon />
                </Link>
                {row.name}
                {addonQuantity > 0 && (
                  <>
                    {' '}
                    <JdsTag color="brand" label="Produto nesta oferta" />
                  </>
                )}
              </span>
              <span>
                {row.values[plan.id]}
                {addonQuantity > 0 && (
                  <span
                    style={{
                      color: 'var(--fg-brand-strong)',
                      fontWeight: 'var(--fw-semibold)',
                    }}
                  >
                    {' '}
                    + {addonQuantity}
                  </span>
                )}
              </span>
            </div>
          );
        })
      )}
    </aside>
  );
}
